import request from '@/utils/http'
// 监察举报
export function addReporter (data) {
  return request({
    url: '/rest/report/add',
    method: 'POST',
    data
  })
}
export function getGovernmentList () {
  return request({
    url: '/rest/report/queryHonestGovernmentList',
    method: 'POST'
  })
}
export function getReportType () {
  return request({
    url: '/rest/report/ajaxListOrgTree',
    method: 'POST'
  })
}



// WEBPACK FOOTER //
// ./src/api/report/index.js